export default __webpack_public_path__ + "static/media/rentals-for-couples.d0ee38d9.jpeg";